import { PropertyData } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { CompPropertyDataState } from '../../types.ts';
import { selectPropertyDataEntities } from './propertyDataSelectors/propertyDataSelectors.ts';

export const selectCompPropertyDataEntities = createSelector(
  [selectPropertyDataEntities],
  (propertyDataEntities) =>
    Object.entries(propertyDataEntities).reduce(
      (acc, [id, propertyData]) => {
        if (id !== 'subject') acc[id] = (propertyData as CompPropertyDataState).compData;
        return acc;
      },
      {} as Record<string, PropertyData>,
    ),
);
